"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sleep = void 0;
const sleep = (duration = 0) => new Promise((resolve) => setTimeout(resolve, duration));
exports.sleep = sleep;
//# sourceMappingURL=sleep.js.map